/**
 * PATH: apps/qa/src/lib/api/ncrs.ts
 * PURPOSE: Non-Conformance Records (NCR) API
 */

import { api, normaliseList } from './helpers'
import type { NCR } from '@/types/qa'

export const ncrApi = {
  getNCRs: async (params?: { job_id?: string; inspection_id?: string; severity?: string; status?: string; page?: number; page_size?: number }): Promise<{ results: NCR[]; count: number; stats?: unknown }> => {
    const response = await api().get('/qa/ncrs/', { params })
    return normaliseList(response.data)
  },
  getNCR: async (id: string): Promise<NCR> => {
    const response = await api().get(`/qa/ncrs/${id}/`)
    return response.data
  },
  createNCR: async (data: { job: string | number; inspection: string; area: string; item_instance?: string | null; title: string; issue_description: string; severity: string; assigned_to?: string | null; due_date?: string | null }): Promise<NCR> => {
    const response = await api().post('/qa/ncrs/', data)
    return response.data
  },
  updateNCR: async (id: string, data: Partial<NCR>): Promise<NCR> => {
    const response = await api().patch(`/qa/ncrs/${id}/`, data)
    return response.data
  },
  addComment: async (id: string, data: { action_text: string }): Promise<NCR> => {
    const response = await api().post(`/qa/ncrs/${id}/comment/`, data)
    return response.data
  },
  startWork: async (id: string): Promise<NCR> => {
    const response = await api().post(`/qa/ncrs/${id}/start/`)
    return response.data
  },
  markReadyForReview: async (id: string): Promise<NCR> => {
    const response = await api().post(`/qa/ncrs/${id}/ready-for-review/`)
    return response.data
  },
  closeNCR: async (id: string, data?: { closeout_notes?: string }): Promise<NCR> => {
    const response = await api().post(`/qa/ncrs/${id}/close/`, data)
    return response.data
  },
}
